import { useMemo } from "react";

import axios from "axios";
import appConfig from "config/appConfig";

import { API_URLS } from "shared/constants";

import BaseConverter from "./converters/baseConverter";

export interface FirebaseLinkOptions {
	link: string;
	iosInfo: {
		iosBundleId: string;
		iosAppStoreId: string;
	};
	androidInfo: {
		androidPackageName: string;
	};
	socialMetaTagInfo: {
		socialTitle: string;
		socialImageLink?: string;
		socialDescription: string;
	};
	domainUriPrefix: string;
	analyticsInfo: {
		googlePlayAnalytics: {
			utmCampaign: string;
			utmMedium: string;
			utmTerm: string;
			utmSource: string;
			utmContent: string;
		};
	};
}

const useClubApiService = () => {
	return useMemo(
		() => ({
			// Deprecated
			// createFBLink: async (data: Partial<FirebaseLinkOptions>, customLink?: string) => {
			// 	return BaseConverter.convert<{
			// 		previewLink: string;
			// 		shortLink: string;
			// 	}>(
			// 		await axios.post(API_URLS.FIREBASE.DEEP_LINK(appConfig.GLOBAL_CONSTANTS.FIREBASE_CONFIG.API_KEY), {
			// 			dynamicLinkInfo: {
			// 				...data,
			// 				link: customLink ? `${window.location.origin}${customLink}` : window.location.href,
			// 				iosInfo: {
			// 					iosBundleId: appConfig.GLOBAL_CONSTANTS.FIREBASE_CONFIG.DYNAMIC_LINKS.MOBILE_IOS_BUNDLE_ID,
			// 					iosAppStoreId: appConfig.GLOBAL_CONSTANTS.FIREBASE_CONFIG.DYNAMIC_LINKS.MOBILE_IOS_STORE_ID
			// 				},
			// 				androidInfo: {
			// 					androidPackageName: appConfig.GLOBAL_CONSTANTS.FIREBASE_CONFIG.DYNAMIC_LINKS.MOBILE_ANDROID_BUNDLE_ID
			// 				},
			// 				domainUriPrefix: appConfig.GLOBAL_CONSTANTS.FIREBASE_CONFIG.DYNAMIC_LINKS.FIREBASE_DYNAMIC_LINK_DOMAIN,
			// 				navigationInfo: {
			// 					enableForcedRedirect: false
			// 				}
			// 			}
			// 		})
			// 	);
			// },
			createDynaLink: async (data: Partial<FirebaseLinkOptions>, customLink?: string) => {
				return BaseConverter.convert<{
					id: number;
					name: string;
					path: string;
					url: string;
					social_description: string;
					social_image_url: string;
					social_title: string;
					shortened_path: string;
					android_fallback_url: string;
					ios_fallback_url: string;
					enable_forced_redirect: boolean;
					referrer: string;
					ios_deferred_deep_linking_enabled: boolean;
					provider_token: string;
					campaign_token: string;
					android_app_id: string;
					ios_app_id: string;
					clicks: number;
				}>(
					// https://dynalinks.readme.io/reference/post_links
					await axios.post(
						API_URLS.DYNALINK.DEEP_LINK,
						{
							path: window.location.pathname?.startsWith("/")
								? window.location.pathname.slice(1)
								: window.location.pathname,
							url: customLink ? `${window.location.origin}${customLink}` : window.location.href,
							social_description: data.socialMetaTagInfo?.socialDescription,
							social_image_url: data.socialMetaTagInfo?.socialImageLink,
							social_title: data.socialMetaTagInfo?.socialTitle,
							enable_forced_redirect: true,
							ios_app: {
								id: appConfig.GLOBAL_CONSTANTS.DYNALINK_IOS_APP_ID
							},
							android_app: {
								id: appConfig.GLOBAL_CONSTANTS.DYNALINK_ANDROID_APP_ID
							},
							options: {
								shorten: true
							}
						},
						{
							headers: {
								accept: "application/json",
								"content-type": "application/json",
								Authorization: `Token ${appConfig.GLOBAL_CONSTANTS.DYNALINK_API_KEY}`
							}
						}
					)
				);
			}
		}),
		[]
	);
};

export default useClubApiService;
